import { HttpForm } from "../Support/HttpForm";
import { axios } from "../Support/Axios";
export class ReportSchedule extends HttpForm {
    slug = false;
    reports = false;
    frequencies = false;
    app;
    selected = false;
    data = {
        report_id: null,
        parameters: {},
        frequency: 'weekly',
        recipients: null,
    };
    constructor(app, params) {
        super();
        this.app = app;
        if (params.schedule) {
            this.slug = params.schedule;
        }
    }
    mount() {
        return Promise.all([
            this.getReports(),
            this.getScheduleFrequencies(),
            this.getScheduledReport()
        ]).then(() => {
            this.setLoadingState(true);
        });
    }
    submitSchedule() {
        if (this.data.uuid) {
            const url = '/api/report/schedule/' + this.data.uuid;
            return axios.patch(url, this.data).then(() => this.navigation.toRouteName('admin.report', {}, { section: 'schedule' })).catch(e => this.setError(e));
        }
        const url = '/api/report/schedule';
        return axios.post(url, this.data).then(() => this.navigation.toRouteName('admin.report', {}, { section: 'schedule' })).catch(e => this.setError(e));
    }
    selectReport(setupFields = true) {
        let self = this;
        const url = '/api/report/' + this.data.report_id;
        return axios.get(url)
            .then(function (response) {
            let report = response.data.data;
            if (setupFields) {
                self.setupReportRenderFields(report);
            }
            self.selected = report;
        })
            .catch(e => this.setError(e));
    }
    setupReportRenderFields(report) {
        let self = this;
        self.data.parameters['export_driver'] = 'MBLSolutions\\Report\\Driver\\QueuedExport\\CsvQueuedExport';
        report.fields.forEach(function (field) {
            self.data.parameters[field.alias] = null;
        });
    }
    getReports() {
        const url = '/api/report/all';
        return axios.get(url)
            .then((response) => this.reports = response.data.data)
            .catch(e => this.setError(e));
    }
    getScheduleFrequencies() {
        const url = '/api/report/schedule/frequency';
        return axios.get(url)
            .then((response) => this.frequencies = response.data)
            .catch(e => this.setError(e));
    }
    getScheduledReport() {
        let self = this;
        if (this.slug) {
            const url = '/api/report/schedule/' + this.slug;
            return axios.get(url)
                .then(function (response) {
                self.data = response.data.data;
                self.selectReport();
            })
                .catch(e => this.setError(e));
        }
        return new Promise(resolve => {
            resolve(true);
        });
    }
    isAdminUser() {
        if (this.app && this.app.auth) {
            return this.app.auth.role === 'admin';
        }
        return false;
    }
}
